import { render, staticRenderFns } from "./ClassesDropdown.vue?vue&type=template&id=dcab15b2&scoped=true&"
import script from "./ClassesDropdown.vue?vue&type=script&lang=ts&"
export * from "./ClassesDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./ClassesDropdown.vue?vue&type=style&index=0&id=dcab15b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcab15b2",
  null
  
)

export default component.exports